import { AuthoritySource, AuthorityStatus, authorityStatusLabels, type SalesLead } from '@/models/salesLead'

const AUTHORITY_COLORS: Record<AuthorityStatus, string> = {
  [AuthorityStatus.ACTIVE]: 'text-green-600',
  [AuthorityStatus.INACTIVE]: 'text-red-600',
  [AuthorityStatus.PENDING]: 'text-red-600',
  [AuthorityStatus.NONE]: 'text-red-600',
  [AuthorityStatus.UNKNOWN]: '',
}

/** The Fleet Info card's authority and interstate rows: FMCSA's answer when it has one, else CAB's. */
export function RegistrationRows({ lead }: { lead: SalesLead }) {
  const interstate = lead.fmcsaInterstate ?? lead.interstate
  return (
    <>
      <div>
        <span className="text-muted-foreground">Authority:</span>{' '}
        {lead.authorityStatus ? (
          <span className={AUTHORITY_COLORS[lead.authorityStatus]}>
            {authorityStatusLabels[lead.authorityStatus]}
          </span>
        ) : (
          // Not classified yet: CAB's own spelling.
          <span>{lead.commonAuthStatus || 'Unknown'}</span>
        )}
        {lead.authoritySource === AuthoritySource.FMCSA && <FmcsaNote />}
      </div>
      <div>
        <span className="text-muted-foreground">Interstate:</span> {interstate ? 'Yes' : 'No'}
        {lead.fmcsaInterstate != null && <FmcsaNote />}
      </div>
    </>
  )
}

function FmcsaNote() {
  return (
    <>
      {' '}
      <span className="text-muted-foreground text-xs">(FMCSA)</span>
    </>
  )
}
